var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopySnippet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#858282",
    d: "M3.61953 2.99992V0.999919C3.61953 0.823108 3.6912 0.653538 3.81877 0.528514C3.94635 0.40349 4.11938 0.333252 4.2998 0.333252H12.4631C12.6435 0.333252 12.8165 0.40349 12.9441 0.528514C13.0717 0.653538 13.1433 0.823108 13.1433 0.999919V10.3333C13.1433 10.5101 13.0717 10.6796 12.9441 10.8047C12.8165 10.9297 12.6435 10.9999 12.4631 10.9999H10.4222V12.9999C10.4222 13.3679 10.1161 13.6666 9.73721 13.6666H1.58347C1.49376 13.6671 1.40483 13.6503 1.32179 13.617C1.23874 13.5837 1.16322 13.5347 1.09957 13.4728C1.03591 13.4108 0.985371 13.3372 0.950855 13.256C0.916339 13.1749 0.898526 13.0878 0.898438 12.9999L0.900478 3.66659C0.900478 3.29859 1.2066 2.99992 1.58551 2.99992H3.61953ZM2.26102 4.33325L2.25898 12.3333H9.0617V4.33325H2.26102ZM4.98007 2.99992H10.4222V9.66659H11.7828V1.66659H4.98007V2.99992Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySnippet);
export default __webpack_public_path__ + "static/media/copy-snippet.e67b6cc8b3de7332ae393920208fa1ab.svg";
export { ForwardRef as ReactComponent };